import type { DateFilterKey } from '../../types';

const OPTIONS: Array<{ key: DateFilterKey; label: string }> = [
  { key: 'all', label: 'Todos' },
  { key: 'fromToday', label: 'A partir de hoje' },
  { key: 'today', label: 'Hoje' },
  { key: 'tomorrow', label: 'Amanhã' },
  { key: 'next7', label: 'Próximos 7 dias' },
];

interface QuarantineDateFilterProps {
  value: DateFilterKey;
  onChange: (key: DateFilterKey) => void;
}

export const QuarantineDateFilter = ({
  value,
  onChange,
}: QuarantineDateFilterProps) => (
  <div
    role="group"
    aria-label="Filtro por data de agendamento"
    className="mb-4 flex flex-wrap items-center gap-2"
  >
    {OPTIONS.map((option) => {
      const active = option.key === value;
      return (
        <button
          key={option.key}
          type="button"
          aria-pressed={active}
          onClick={() => onChange(option.key)}
          className={`h-8 rounded-full border px-3 text-xs font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#EE7C2C] ${
            active
              ? 'border-[#EE7C2C] bg-[#EE7C2C] text-white'
              : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50'
          }`}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
